module.exports = __webpack_public_path__ + "static/media/03.6e95563a.mp3";